import type { Condition } from './condition';
import { validate as validateCondition } from './condition';

type ValidationErrors = Record<string, string[]>;

export type Kycc = {
  id: number | null;
  companyId: number | null;
  conditions: Array<Condition>;
  kyccMonthlyLimit: number;
  kyccCheckedCount: number;
  errors: ValidationErrors;
};

export type Customer = Kycc & {};
export type CustomerOversea = Kycc & {};
export type Company = Kycc & {};
export type CompanyOversea = Kycc & {};

export const Target = {
  domestic: 0,
  oversea: 1,
};

export function validate(kycc: Customer | Company): boolean {
  let errorsCount = 0;

  kycc.errors = {};
  if (kycc.conditions.length > 0) {
    kycc.conditions.forEach(kycc => {
      if (!validateCondition(kycc)) {
        errorsCount += Object.keys(kycc.errors).length;
      }
    });
  } else {
    kycc.errors['base'] = ['対象を入力してください'];
    errorsCount++;
  }

  return errorsCount == 0;
}

export function hasError(kycc: Kycc, field: string): boolean {
  const errorMessages = Object.getOwnPropertyDescriptor(
    kycc.errors,
    field,
  )?.value;
  return Array.isArray(errorMessages) && errorMessages.length > 0;
}
